import { TextField, TextFieldProps } from '@material-ui/core'

const HOURS = Array.from(Array(24).keys())
const MINUTES = Array.from(Array(60).keys())

export type TimePickerProps = {
  pickerType: 'hours' | 'minutes'
} & TextFieldProps

export const TimePicker = (props: TimePickerProps) => {
  const { pickerType } = props

  return (
    <div>
      <TextField
        select
        label={pickerType === 'hours' ? '-Hrs-' : '-Mins-'}
        variant="outlined"
        SelectProps={{
          native: true,
        }}
        InputLabelProps={{
          required: false,
          style: { color: 'GrayText' },
        }}
        style={{
          width: '110px',
        }}
        {...props}
      >
        <option aria-label="None" value="" disabled hidden />
        {(pickerType === 'hours' ? HOURS : MINUTES).map((option) => (
          <option key={option} value={option < 10 ? '0' + option : option}>
            {option < 10 ? '0' + option : option}
          </option>
        ))}
      </TextField>
    </div>
  )
}
